import { Paper } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled(Paper)`
    padding: 16px;
    display: flex;
    height: 100%;
    overflow: auto; 
    flex-direction: column;
`;

export const CardTitle = styled.h2`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: #031795;
`;

export const AddParticipantContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 16px;
    gap: 8px;
`;

export const SelectContainer = styled.div`
    display: grid;
    width: 100%;
`;

export const AccessCheckboxList = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    overflow: auto;
    margin-top: 16px;
`;

export const ParticipantListContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
  margin-top: 16px;
  gap: 12px;
`;

export const ParticipantBox = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px;
  gap: 6px;
  border: 1px solid #949494;
`;

export const ParticipantName = styled.span`
  font-size: 16px;
  color: #000;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
`;

export const ParticipantLink = styled.a`
  color: #000;
  width: 24px;
  height: 24px;

  cursor: pointer;
  transition: color 0.2s;

  :hover {
    color: #4f4f4f;
  }
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;  
  gap: 8px;
`;

export const ActionButton = styled.a`
  color: #000;
  width: 24px;
  height: 24px;
  
  svg {
    color: #000;
    cursor: pointer;
    transition: color 0.2s;
  
    :hover {
      color: #4f4f4f;
    }
  }
`;
